// LucideIcon.tsx
import React, { Suspense } from 'react'
import type { LucideProps } from 'lucide-react'
import { File, Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LucideIconProps extends LucideProps {
  name: string
  fallback?: React.ReactNode
}

export const LucideIcon: React.FC<LucideIconProps> = ({
  name,
  className,
  ...props
}) => {
  const LazyLucideIcon = React.useMemo<
    React.LazyExoticComponent<React.ComponentType<LucideProps>>
  >(() => {
    return React.lazy(async () => {
      try {
        const pascalName = name
          .split('-')
          .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
          .join('')

        const mod = await import('lucide-react')
        const IconComp = (mod as any)[
          pascalName
        ] as React.ComponentType<LucideProps>

        return {
          default: IconComp ?? File,
        }
      } catch {
        return { default: File }
      }
    })
  }, [name])

  return (
    <Suspense
      fallback={
        <Loader2
          {...props}
          className={cn('animate-spin transition-colors hidden', className)}
        />
      }
    >
      <LazyLucideIcon {...props} className={className} />
    </Suspense>
  )
}
